module.exports = "https://img.zhijierongxing.com/saas/img/rmb_icon3.7b041e32.png";